export function getSlaStatusFromDueDates(
    dueDateValues: (string | number | Date | { item2: string })[]
): string[] {
    if (!dueDateValues?.length) return [];

    const results = new Set<string>();

    const now = new Date(Date.now());

    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);

    for (const entry of dueDateValues) {
        const raw = typeof entry === 'object' && entry !== null && 'item2' in entry
            ? (entry as { item2: string }).item2
            : entry;

        if (raw == null) continue;

        const slaDueDate = new Date(raw as string | number | Date);
        if (isNaN(slaDueDate.getTime())) continue;

        const startOfDueDate = new Date(slaDueDate);
        startOfDueDate.setHours(0, 0, 0, 0);

        if (slaDueDate.getTime() < now.getTime()) {
            results.add('pastDue');
            continue;
        }

        const diffDays =
            (startOfDueDate.getTime() - startOfToday.getTime()) /
            (1000 * 60 * 60 * 24);

        if (diffDays === 0) {
            results.add('dueToday');
        } else if (diffDays === 1) {
            results.add('dueTomorrow');
        }
    }

    return Array.from(results);
}
